import { render, staticRenderFns } from "./NewVariableInput.vue?vue&type=template&id=08bcdbca&scoped=true&"
import script from "./NewVariableInput.vue?vue&type=script&lang=ts&"
export * from "./NewVariableInput.vue?vue&type=script&lang=ts&"
import style0 from "./NewVariableInput.vue?vue&type=style&index=0&id=08bcdbca&lang=scss&scoped=true&"
import style1 from "./NewVariableInput.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bcdbca",
  null
  
)

export default component.exports